import { useTranslation } from 'react-i18next';

const avatarUrls: Record<number, string> = {
  0: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20caucasian%20woman%20with%20blonde%20hair%20on%20clean%20white%20studio%20background%20friendly%20smile%20confident%20expression%20modern%20business%20casual%20navy%20blazer&width=80&height=80&seq=testimonial-avatar-0-v2&orientation=squarish",
  1: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20east%20asian%20man%20with%20glasses%20on%20clean%20white%20studio%20background%20warm%20friendly%20smile%20confident%20expression%20modern%20business%20casual%20grey%20sweater&width=80&height=80&seq=testimonial-avatar-1-v2&orientation=squarish",
  2: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20latina%20woman%20with%20dark%20curly%20hair%20on%20clean%20white%20studio%20background%20genuine%20smile%20confident%20expression%20modern%20business%20casual%20white%20blouse&width=80&height=80&seq=testimonial-avatar-2-v2&orientation=squarish",
  3: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20african%20american%20man%20with%20short%20hair%20on%20clean%20white%20studio%20background%20warm%20smile%20confident%20expression%20modern%20business%20casual%20light%20blue%20shirt&width=80&height=80&seq=testimonial-avatar-3-v2&orientation=squarish",
  4: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20southeast%20asian%20woman%20with%20long%20dark%20hair%20on%20clean%20white%20studio%20background%20friendly%20smile%20confident%20expression%20modern%20business%20casual%20beige%20blazer&width=80&height=80&seq=testimonial-avatar-4-v2&orientation=squarish",
  5: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20middle%20eastern%20man%20with%20beard%20on%20clean%20white%20studio%20background%20warm%20smile%20confident%20expression%20modern%20business%20casual%20white%20shirt&width=80&height=80&seq=testimonial-avatar-5-v2&orientation=squarish",
};

export default function Testimonials() {
  const { t } = useTranslation();

  return (
    <section className="py-24 md:py-32 bg-background-100">
      <div className="w-full px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-2 mb-4">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            <span className="text-xs font-medium text-foreground-600 tracking-wide uppercase">
              {t('testimonials.label', 'Seller Reviews')}
            </span>
          </div>
          <h2 className="text-3xl md:text-[40px] font-bold text-foreground-950 leading-tight">
            {t('testimonials.title_line1', 'Trusted by Dropshippers')}
            <br />
            {t('testimonials.title_line2', 'Worldwide')}
          </h2>
          <p className="mt-4 text-foreground-600 text-base max-w-lg mx-auto">
            {t('testimonials.subtitle')}
          </p>
        </div>

        {/* Reviews Grid - 2 rows × 3 columns */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {[0, 1, 2, 3, 4, 5].map((i) => {
            const isFaded = i === 5;
            return (
              <div
                key={i}
                className={`rounded-2xl bg-white p-6 ${
                  isFaded ? 'opacity-70' : ''
                }`}
              >
                {/* Stars */}
                <div className="flex gap-1 mb-4">
                  {[...Array(5)].map((_, s) => (
                    <i
                      key={s}
                      className="ri-star-fill text-sm text-accent-500"
                    ></i>
                  ))}
                </div>
                {/* Title */}
                <h4 className={`text-lg font-bold text-foreground-900 mb-2 ${isFaded ? 'text-foreground-500' : ''}`}>
                  {t(`testimonials.reviews.${i}.title`)}
                </h4>
                {/* Body */}
                <p className={`text-sm leading-relaxed mb-5 ${isFaded ? 'text-foreground-400' : 'text-foreground-600'}`}>
                  {t(`testimonials.reviews.${i}.body`)}
                </p>
                {/* Author */}
                <div className="flex items-center gap-3 pt-4 border-t border-secondary-100">
                  <img
                    src={avatarUrls[i]}
                    alt={t(`testimonials.reviews.${i}.name`)}
                    className="w-10 h-10 rounded-full object-cover"
                  />
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">
                      {t(`testimonials.reviews.${i}.name`)}
                    </p>
                    <p className="text-xs text-foreground-500">
                      {t(`testimonials.reviews.${i}.role`)}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}